export default __webpack_public_path__ + "static/media/transfer.7d8f838f.svg";